export default {
  name: "ProjectImporter",
  path: "/project-importer",
  component: () => import("@/views/ProjectImporter")
};
